import { render, staticRenderFns } from "./PagesAdmin.vue?vue&type=template&id=3dd3f1f4"
import script from "./PagesAdmin.vue?vue&type=script&lang=js"
export * from "./PagesAdmin.vue?vue&type=script&lang=js"
import style0 from "./PagesAdmin.vue?vue&type=style&index=0&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports